<template>
  <div>
    <main-navigation></main-navigation>

    <div class="page-wrapper">
      <div class="container">
        <div class="card">

          <!-- Header -->
          <div class="card-header">
            <div class="header-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
            </div>
            <div>
              <h4>Edit Business Profile</h4>
              <p>Update your business information</p>
            </div>
          </div>

          <!-- Loading State -->
          <div v-if="loadingProfile" class="loading-state">
            <div class="spinner"></div>
            <p>Loading profile...</p>
          </div>

          <!-- Profile Form -->
          <form @submit.prevent="updateProfile" v-else>
            <div class="form-grid">

              <!-- Business Name -->
              <div class="form-field">
                <label for="business_name">Business Name <span class="required">*</span></label>
                <input
                  id="business_name"
                  v-model="form.Business_name"
                  type="text"
                  placeholder="Enter business name"
                  :class="{ 'error': errors.Business_name }"
                />
                <small v-if="originalForm.Business_name">Current: {{ originalForm.Business_name }}</small>
                <span class="error-msg" v-if="errors.Business_name">{{ errors.Business_name }}</span>
              </div>

              <!-- Business Phone -->
              <div class="form-field">
                <label for="business_phone">Business Phone <span class="required">*</span></label>
                <input
                  id="business_phone"
                  v-model="form.Business_phone"
                  type="tel"
                  placeholder="Enter phone number"
                  :class="{ 'error': errors.Business_phone }"
                />
                <small v-if="originalForm.Business_phone">Current: {{ originalForm.Business_phone }}</small>
                <span class="error-msg" v-if="errors.Business_phone">{{ errors.Business_phone }}</span>
              </div>

              <!-- Business Address -->
              <div class="form-field full-width">
                <label for="business_address">Business Address</label>
                <textarea
                  id="business_address"
                  v-model="form.Business_address"
                  rows="2"
                  placeholder="Enter business address"
                ></textarea>
                <small v-if="originalForm.Business_address">Current: {{ originalForm.Business_address }}</small>
              </div>

              <!-- Paybill Type -->
              <div class="form-field">
                <label for="paybill_type">Payment Method</label>
                <select id="paybill_type" v-model="form.paybill_type">
                  <option value="">Select payment method</option>
                  <option value="Safaricom Till">Safaricom Till</option>
                  <option value="Safaricom Paybill">Safaricom Paybill</option>
                  <option value="Pochi">Pochi</option>
                  <option value="Phone Number">Phone Number</option>
                  <option value="Bank Paybill">Bank Paybill</option>
                </select>
                <small v-if="originalForm.paybill_type">Current: {{ originalForm.paybill_type }}</small>
              </div>

              <!-- Reference number — label + placeholder change based on paybill_type -->
              <div class="form-field">
                <label for="short_code">
                  {{ shortCodeLabel }}
                  <span class="required" v-if="form.paybill_type">*</span>
                </label>
                <input
                  id="short_code"
                  v-model="form.BusinessShortCode"
                  type="text"
                  :placeholder="shortCodePlaceholder"
                  :disabled="!form.paybill_type"
                  :class="{ 'error': errors.BusinessShortCode }"
                />
                <small v-if="originalForm.BusinessShortCode">Current: {{ originalForm.BusinessShortCode }}</small>
                <span class="error-msg" v-if="errors.BusinessShortCode">{{ errors.BusinessShortCode }}</span>
              </div>

              <!-- Account / reference — now shown for every payment method, label adapts -->
              <div class="form-field full-width">
                <label for="account">{{ accountLabel }}</label>
                <input
                  id="account"
                  v-model="form.account"
                  type="text"
                  :placeholder="accountPlaceholder"
                  :disabled="!form.paybill_type"
                />
                <small v-if="originalForm.account">Current: {{ originalForm.account }}</small>
              </div>

            </div>

            <!-- Unsaved Changes Warning -->
            <div class="unsaved-warning" v-if="hasChanges">
              <span><i class="bi bi-exclamation-triangle"></i> You have unsaved changes</span>
            </div>

            <!-- Action Buttons -->
            <div class="form-actions">
              <button
                type="button"
                class="btn-secondary"
                @click="resetForm"
                :disabled="loadingUpdate || !hasChanges"
              >
                Reset
              </button>
              <button
                type="submit"
                class="btn-primary"
                :disabled="loadingUpdate || !hasChanges"
              >
                <span v-if="loadingUpdate">Updating...</span>
                <span v-else>Update Profile</span>
              </button>
            </div>
          </form>

          <!-- Message Toast -->
          <div v-if="message" class="toast" :class="success ? 'toast-success' : 'toast-error'">
            {{ message }}
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import { apiFetch } from '@/services/api';
export default {
  name: "UpdateProfile",

  data() {
    return {
      loadingProfile: false,
      loadingUpdate: false,
      message: "",
      success: false,
      API_BASE_URL:'https://golang.roberms.com/api', //'https://golang.roberms.com/api',

      form: {
        Business_name: "",
        Business_address: "",
        Business_phone: "",
        BusinessShortCode: "",
        paybill_type: "",
        account: ""
      },

      originalForm: {},
      errors: {}
    };
  },

  computed: {
    hasChanges() {
      return JSON.stringify(this.form) !== JSON.stringify(this.originalForm);
    },

    shortCodeLabel() {
      const labels = {
        'Safaricom Till': 'Till Number',
        'Safaricom Paybill': 'Paybill Number',
        'Pochi': 'Pochi Number',
        'Phone Number': 'Phone Number',
        'Bank Paybill': 'Paybill Number',
      };
      return labels[this.form.paybill_type] || 'Paybill / Till Number';
    },

    shortCodePlaceholder() {
      if (!this.form.paybill_type) return 'Select a payment method first';
      const placeholders = {
        'Safaricom Till': 'e.g. 123456',
        'Safaricom Paybill': 'e.g. 400200',
        'Pochi': 'e.g. 0712345678',
        'Phone Number': 'e.g. 0712345678',
        'Bank Paybill': 'e.g. 400200',
      };
      return placeholders[this.form.paybill_type] || '';
    },

    accountLabel() {
      const labels = {
        'Safaricom Till': 'Account / Reference',
        'Safaricom Paybill': 'Account Number',
        'Pochi': 'Reference Name',
        'Phone Number': 'Reference Name',
        'Bank Paybill': 'Account Number',
      };
      return labels[this.form.paybill_type] || 'Account / Reference';
    },

    accountPlaceholder() {
      if (!this.form.paybill_type) return 'Select a payment method first';
      const placeholders = {
        'Safaricom Till': 'e.g. Rent collection',
        'Safaricom Paybill': 'e.g. 001234',
        'Pochi': 'e.g. Business owner name',
        'Phone Number': 'e.g. Rent payment',
        'Bank Paybill': 'e.g. 001234',
      };
      return placeholders[this.form.paybill_type] || '';
    }
  },

  async mounted() {
    await this.fetchProfile();
  },

  methods: {
    async apiCall(endpoint, options = {}) {
      const token = localStorage.getItem("token");

      if (!token) {
        throw new Error("No authentication token found");
      }

      const response = await fetch(`${this.API_BASE_URL}${endpoint}`, {
        ...options,
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
          ...options.headers
        }
      });

      if (!response.ok) {
        const error = await response.text();
        throw new Error(error || `HTTP ${response.status}`);
      }

      return await response.json();
    },

    async fetchProfile() {
      try {
        this.loadingProfile = true;
        const response = await this.apiCall("/profile");

        const profile = response.data || response;

        if (profile) {
          this.form = {
            Business_name: profile.Business_name || "",
            Business_address: profile.Business_address || "",
            Business_phone: profile.Business_phone || "",
            BusinessShortCode: profile.BusinessShortCode || "",
            paybill_type: profile.paybill_type || "",
            account: profile.account || ""
          };
          this.originalForm = { ...this.form };
        }
      } catch (error) {
        console.error("Failed to load profile:", error);
      } finally {
        this.loadingProfile = false;
      }
    },

    validateForm() {
      this.errors = {};
      if (!this.form.Business_name?.trim()) this.errors.Business_name = "Business name is required";
      if (!this.form.Business_phone?.trim()) this.errors.Business_phone = "Business phone is required";
      if (this.form.paybill_type && !this.form.BusinessShortCode?.trim()) {
        this.errors.BusinessShortCode = `${this.shortCodeLabel} is required`;
      }
      return Object.keys(this.errors).length === 0;
    },

    async updateProfile() {
      if (!this.validateForm()) return;

      this.loadingUpdate = true;
      this.message = "";

      try {
        const token = localStorage.getItem('token');
        const res = await fetch(`${this.API_BASE_URL}/send-otp`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
          body: JSON.stringify({
            action_type: 'edit_profile',
            payload: {
              Business_name: this.form.Business_name,
              Business_address: this.form.Business_address,
              Business_phone: this.form.Business_phone,
              paybill_type: this.form.paybill_type,
              BusinessShortCode: this.form.BusinessShortCode,
              account: this.form.account,
            },
          }),
        });

        const data = await res.json();

        if (res.status === 200) {
          this.$router.push({ path: '/sendOtp/', query: { action_type: 'edit_profile' } });
        } else {
          this.success = false;
          this.message = data.error || 'Failed to send confirmation code';
          setTimeout(() => {
            this.message = "";
          }, 3000);
        }
      } catch (e) {
        this.success = false;
        this.message = e.message || 'Failed to update your profile';
        setTimeout(() => {
          this.message = "";
        }, 3000);
      } finally {
        this.loadingUpdate = false;
      }
    },

    resetForm() {
      this.form = { ...this.originalForm };
      this.errors = {};
    }
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.page-wrapper {
  background: var(--dash-bg);
  min-height: 100vh;
  display: flex;
  align-items: center;
  padding: 20px;
}

.container {
  max-width: 900px;
  margin: 0 auto;
  width: 100%;
}

.card {
  background: white;
  border-radius: var(--dash-radius);
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  overflow: hidden;
}

/* Header */
.card-header {
  padding: 20px 24px;
  background: var(--dash-surface-2);
  border-bottom: 1px solid var(--dash-line);
  display: flex;
  align-items: center;
  gap: 12px;
}

.header-icon {
  width: 40px;
  height: 40px;
  background: var(--dash-line);
  border-radius: var(--dash-radius-sm);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--dash-muted);
  flex-shrink: 0;
}

.card-header h4 {
  font-size: 18px;
  font-weight: 600;
  color: var(--dash-text);
  margin-bottom: 2px;
}

.card-header p {
  font-size: 13px;
  color: var(--dash-faint);
  margin: 0;
}

/* Form Grid */
.form-grid {
  padding: 24px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px 20px;
  align-items: start;
}

.form-field {
  display: flex;
  flex-direction: column;
}

.form-field.full-width {
  grid-column: span 2;
}

/* Form Fields */
.form-field label {
  display: block;
  font-size: 13px;
  font-weight: 500;
  color: var(--dash-muted);
  margin-bottom: 6px;
  min-height: 18px;
}

.form-field .required {
  color: var(--dash-danger);
}

.form-field input,
.form-field select,
.form-field textarea {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid var(--dash-line);
  border-radius: var(--dash-radius);
  font-size: 14px;
  transition: all 0.2s;
  background: white;
  font-family: inherit;
}

.form-field input:disabled {
  background: var(--dash-bg-alt);
  color: var(--dash-faint);
  cursor: not-allowed;
}

.form-field input:focus,
.form-field select:focus,
.form-field textarea:focus {
  outline: none;
  border-color: var(--dash-primary);
  box-shadow: 0 0 0 2px rgba(74,144,226,0.1);
}

.form-field input.error,
.form-field select.error {
  border-color: var(--dash-danger);
}

.form-field small {
  display: block;
  font-size: 11px;
  color: var(--dash-faint);
  margin-top: 4px;
}

.form-field .error-msg {
  display: block;
  font-size: 11px;
  color: var(--dash-danger);
  margin-top: 4px;
}

/* Loading State */
.loading-state {
  padding: 60px 24px;
  text-align: center;
}

.spinner {
  width: 32px;
  height: 32px;
  border: 3px solid var(--dash-line);
  border-top-color: var(--dash-primary);
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
  margin: 0 auto 12px;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.loading-state p {
  color: var(--dash-faint);
  font-size: 13px;
}

/* Unsaved Warning */
.unsaved-warning {
  margin: 0 24px 16px 24px;
  padding: 8px 12px;
  background: var(--dash-warning-soft);
  border-left: 3px solid var(--dash-warning);
  border-radius: var(--dash-radius-xs);
}

.unsaved-warning span {
  font-size: 12px;
  color: var(--dash-warning-ink);
}

/* Form Actions */
.form-actions {
  padding: 16px 24px;
  background: var(--dash-surface-2);
  border-top: 1px solid var(--dash-line);
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.btn-primary,
.btn-secondary {
  padding: 8px 20px;
  border-radius: var(--dash-pill);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
}

.btn-primary {
  background: var(--dash-primary);
  color: white;
}

.btn-primary:hover:not(:disabled) {
  background: var(--dash-primary-hover);
  transform: translateY(-1px);
}

.btn-secondary {
  background: white;
  color: var(--dash-muted);
  border: 1px solid var(--dash-line);
}

.btn-secondary:hover:not(:disabled) {
  background: var(--dash-bg-alt);
  border-color: var(--dash-line-strong);
}

.btn-primary:disabled,
.btn-secondary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Toast Message */
.toast {
  position: fixed;
  bottom: 20px;
  right: 20px;
  padding: 10px 20px;
  border-radius: var(--dash-radius-xs);
  font-size: 13px;
  font-weight: 500;
  animation: slideUp 0.3s ease-out;
  z-index: 1000;
}

.toast-success {
  background: var(--dash-success-soft);
  color: var(--dash-success-ink);
  border-left: 3px solid var(--dash-success);
}

.toast-error {
  background: var(--dash-danger-soft);
  color: var(--dash-danger-ink);
  border-left: 3px solid var(--dash-danger);
}

@keyframes slideUp {
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* Responsive */
@media (max-width: 640px) {
  .form-grid {
    grid-template-columns: 1fr;
    gap: 12px;
    padding: 20px;
  }

  .form-field.full-width {
    grid-column: span 1;
  }

  .card-header {
    padding: 16px 20px;
  }

  .form-actions {
    padding: 12px 20px;
  }

  .toast {
    bottom: 10px;
    right: 10px;
    left: 10px;
  }
}
</style>